import { Children } from 'react';

import type { ReactElement } from 'react';
import type { SortableItemProps } from './components/SortableItem';

import { SortableItem } from './components/SortableItem';
import { SortableProvider } from './SortableProvider';

export type Index = string | number;

export interface SortableProps {
  /** The elements to show inside the Sortable. */
  children: ReactElement[] | string[];
  /** The placement of each item Handle (6 dots 2x3). */
  ItemHandlePlacement?: SortableItemProps['handlePlacement'];
  /** If true, a scrollable version of the list will be rendered (max height 21rem/336px). */
  scrollable?: boolean;
  /** If true, the sorting will be disabled. */
  disabled?: boolean;
  /** The callback function that is invoked when new sorting takes place. */
  onSort?: (items: (string | ReactElement)[]) => void;
}

// A component that renders a list of children that can be sorted with drag and drop.
export const Sortable = ({ children, ItemHandlePlacement = 'left', scrollable, disabled, onSort }: SortableProps) => {
  return (
    <SortableProvider
      items={children}
      scrollable={scrollable}
      onSort={onSort}
      key={`sortable-with-children-${Children.count(children)}`}
    >
      {children.map((child, index) => (
        <SortableItem
          handlePlacement={ItemHandlePlacement}
          disabled={disabled || Children.count(children) <= 1}
          index={index}
          key={`sortable-item-${index}`}
        >
          {child}
        </SortableItem>
      ))}
    </SortableProvider>
  );
};
